export default "__VITE_ASSET__CHFFODop__"